import axios from '../config/axios';
import { fetchEntryById } from './fetchEntryById';

export async function searchEntries({
  token,
  searchTerm,
  searchType,
  searchPayload,
  viewerTypeIds,
  viewerSubtypeIds,
  broadSearchTitle = true,
  broadSearchKeywords = true,
  broadSearchCategory = true,
  broadSearchDetail = false,
  onlyMine = false,
  pageNumber = 0,
  itemsPerPage = 30,
}) {
  const offset = pageNumber * itemsPerPage;

  const { data } = await axios.put(
    '/userdatad/search',
    {
      searchTerm,
      searchType,
      searchPayload,
      viewerTypeIds,
      viewerSubtypeIds,

      broadSearchTitle,
      broadSearchKeywords,
      broadSearchCategory,
      broadSearchDetail,
      onlyMine,

      limit: itemsPerPage,
      offset,
    },
    { headers: { Authorization: `Bearer ${token}` } }
  );

  let firstEntry = null;
  if (data.entries.length > 0) {
    firstEntry = await fetchEntryById(data.entries[0].id, token);
  }

  return { data, firstEntry };
}
